export const API_KEY = 'k2KBqayuis1lSBJDhJ2h9noy2p6xkfUq';

export const API_URL = 'https://api.giphy.com/v1';